module.exports = __webpack_public_path__ + "static/media/des2.1fefa765.jpg";